/**
 * @fileoverview api.js
 * 
 * © 2026 KITH Travels (Pvt) Ltd. All rights reserved.
 * This software is the confidential and proprietary information of KITH Travels.
 * You shall not disclose such Confidential Information and shall use it only in 
 * accordance with the terms of the license agreement you entered into with KITH Travels.
 */
const API_URL = import.meta.env.VITE_API_URL || 'https://engine.kithtravels.com/api';

const cache = {};
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const apiFetch = async (endpoint, options = {}) => {
  const url = `${API_URL}${endpoint}`;
  const isGet = !options.method || options.method.toUpperCase() === 'GET';

  if (isGet) {
    const cached = cache[url];
    if (cached && (Date.now() - cached.timestamp < CACHE_DURATION)) {
      return cached.data;
    }
  }

  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || 'API request failed');
  }

  if (isGet) {
    cache[url] = {
      data,
      timestamp: Date.now()
    };
  }

  return data;
};

export const prefetchApi = (endpoint) => {
  apiFetch(endpoint).catch(() => {});
};

export const clearApiCache = () => {
  for (const key in cache) {
    delete cache[key];
  }
};
